import ErrorComponent from "./components/universal/error";

export default function NotFoundPage() {
  return (
    <ErrorComponent
      title="404 - Page Not Found"
      text="Sorry, the page you are looking for does not exist."
    />
  );
}
